import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const TourismIntroPage = () => {
  return <SanityContentPage slug='tourism-intro' />
}

export default TourismIntroPage
